import { render, staticRenderFns } from "./RelatedResources.vue?vue&type=template&id=44091b00&"
import script from "./RelatedResources.vue?vue&type=script&lang=js&"
export * from "./RelatedResources.vue?vue&type=script&lang=js&"
import style0 from "./RelatedResources.vue?vue&type=style&index=0&id=44091b00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports